import { CoreStore, handleStoreState } from "./RESTStore/CoreStore";
import { observable, action, runInAction, makeObservable } from "mobx";
import { API_URL } from "General/APIEndpoints";
import { API } from "General/API";
import { projectsDataStore } from "./ProjectsStore";

export interface WOPIViewerParams {
  archived?: boolean;
  edit?: boolean;
  fileName: string;
  linkId?: number;
}

export class WOPIViewerStore extends CoreStore {
  data: API_WopiTokenInfo = {};
  fileName: string = "";
  isVisible: boolean = false;

  private currentFileId: number;

  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      fileName: observable,
      isVisible: observable,
      fetchEditToken: action.bound,
      hideModal: action.bound,
      fetch: action.bound,
      show: action.bound,
    });
  }

  url(fileId: number) {
    return API_URL.WOPI.generateAccessToken(projectsDataStore.projectId, fileId);
  }

  clear() {
    this.isVisible = false;
    this.fileName = "";
    this.data = {};
    this.currentFileId = undefined;
  }

  @handleStoreState()
  async fetch(fileId: number, params: WOPIViewerParams) {
    try {
      this.fileName = params.fileName;
      this.isVisible = true;

      const response = await API.getData(this.url(fileId), params);
      runInAction(() => {
        this.data = response;
        this.currentFileId = fileId;
      });
    } catch (err) {
      runInAction(() => {
        this.isVisible = false;
      });
      throw err;
    }
  }

  async fetchEditToken(): Promise<API_WopiTokenInfo> {
    try {
      return await API.getData(this.url(this.currentFileId), { edit: true });
    } catch (error) {
      throw error;
    }
  }

  hideModal() {
    this.clear();
  }

  @handleStoreState()
  show() {
    this.isVisible = true;
  }
}

export const wopiViewerStore = new WOPIViewerStore();
